module.exports = __webpack_public_path__ + "img/coin-exchange-banner.e8c7f45c.png";